import { client } from '../..'
import { CHANGE_LOCALE, CHANGE_TIMEZONE } from './Mutations'
import {
  ChangeLocaleMutation,
  ChangeLocaleMutationVariables,
  ChangeTimezoneMutation,
  LocalesQuery,
  LocalesQueryVariables,
  ChangeTimezoneMutationVariables,
} from '../../types'
import { FetchResult, MaybeMasked, QueryResult, useQuery } from '@apollo/client'
import { LOCALES } from './Queries'

export const changeLocale = async (employeeId: number, locale: string): Promise<FetchResult<MaybeMasked<ChangeLocaleMutation>>> => {
  return client.mutate<ChangeLocaleMutation, ChangeLocaleMutationVariables>({
    mutation: CHANGE_LOCALE,
    variables: { employeeId, locale },
  })
}

export const changeTimezone = async (employeeId: number, timezone: string): Promise<FetchResult<MaybeMasked<ChangeTimezoneMutation>>> => {
  return client.mutate<ChangeTimezoneMutation, ChangeTimezoneMutationVariables>({
    mutation: CHANGE_TIMEZONE,
    variables: { employeeId, timezone },
  })
}

export const useLocales = (): QueryResult<LocalesQuery, LocalesQueryVariables> => {
  return useQuery<LocalesQuery, LocalesQueryVariables>(LOCALES, {
    fetchPolicy: 'network-only',
  })
}
